define('lq/events/actions/paypal',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function Paypal(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Paypal, EventAction);

    Paypal.typeName = 'Paypal';

    Paypal.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Paypal.prototype.execute = function () {
        var data = {
            actionId: this.piping.actionId,
            morphId: this.eventData.command,
            parameters: this.piping.parameters.getNonSystemParameters()
        };

        this.piping.dispatcher.dispatch('LicquidAction/CreatePayPalCheckout', data)
            .done(this.paymentInitialized.bind(this));
    };

    Paypal.prototype.paymentInitialized = function (initializedPayment) {
        window.location.href = initializedPayment.approvalUrl;
    };

    return Paypal;
});
